import { Edit, SimpleForm, type EditProps } from "react-admin";
import { HouseVisitEventFormFields } from "./HouseVisitEventFormFields";

export const HouseVisitEventEdit = (props: EditProps) => (
  <Edit {...props} redirect={false}>
    <SimpleForm warnWhenUnsavedChanges sx={{ maxWidth: { xs: "100%", sm: 560 } }}>
      <HouseVisitEventFormFields />
    </SimpleForm>
  </Edit>
);
